import React, { useEffect } from "react";
import  {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import Autocomplete from 'react-google-autocomplete';



export default function GoogleApi({coordinates,setCoordinates,direccion,setAddress}) {
  useEffect(()=>{
    handleSelect(direccion)
    // eslint-disable-next-line
  },[])
  const handleSelect = async value => {
    // console.log(value)
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    setAddress(value);
    setCoordinates(latLng);
  };
  return (
    <Autocomplete
    style={{width: '100%',marginBottom:0}}
    onPlaceSelected={(place) => {
      if(place.formatted_address){
        handleSelect(place.formatted_address);
      }
      else{
        handleSelect(place.name)
      }
      
    }}
    
    types={'address'}
    defaultValue={`${direccion}`}
  />
  );
}